export const wordjoiner = "\u200D";
